import { useMediaQuery } from './use-media-query';

/**
 * Returns true when the viewport is at the Tailwind `lg` breakpoint (1024 px+).
 * SSR-safe: returns false on the server and during the first client render.
 */
export function useIsLargeDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)');
}
